import React, { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/userLegacyCode'
import { Button } from '@/components/button'
import { useLocalization } from '@/hooks/localization'
import { dialogTypes } from '@/dialogs'
import LoadingIndicator from '@/components/LoadingIndicator'

const LegacyCode = ({ openDialog, updateLegacyCode, getLegacyCode, userLegacyCode, userId }) => {
  const { localize } = useLocalization()
  const handleClick = useCallback(() => openDialog({
    dialogType: dialogTypes.editLegacyCode,
    onAction: (legacyCode) => updateLegacyCode({ id: userId, legacyCode }),
    legacyCode: userLegacyCode.legacyCode
  }), [openDialog, userLegacyCode.legacyCode, updateLegacyCode, userId])
  useEffect(() => {
    if (userId) { getLegacyCode(userId) }
  }, [getLegacyCode, userId])

  const isLoading = !userId || userLegacyCode.fetching || userLegacyCode.updating
  return (
    <React.Fragment>
      {isLoading && <LoadingIndicator inline />}
      {!isLoading && <React.Fragment>
        <span className='mr-2'>{userLegacyCode.legacyCode}</span>
        <div>
          <Button onClick={handleClick} title={localize('Common.Edit')}>...</Button>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}

const mapStateToProps = (state, ownProps) => ({
  userLegacyCode: state.userLegacyCode,
  ...ownProps
})

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog,
  getLegacyCode: actionCreators.getLegacyCode,
  updateLegacyCode: actionCreators.updateLegacyCode
}

export default connect(mapStateToProps, mapDispatchToProps)(LegacyCode)



// WEBPACK FOOTER //
// ./src/components/usersManagement/legacyCode.js